import anime from 'animejs'
import React from 'react'
import imagotipo from '../../assets/imagotipo.png'
import { splashScreenStyle } from './SplashScreenStyle'

const SplashScreen = () => {
  const classes = splashScreenStyle()

  const handleAnimation = () =>
    anime({
      targets: window.document.getElementById('wrapper_animation'),
      scale: [{ value: 0.75 }, { value: 1.0 }],
      duration: 2700,
      opacity: [{ value: 0.5 }, { value: 1 }],
      elasticity: 400,
      loop: true,
    })

  return (
    <div className={classes.wrapper}>
      <img id="wrapper_animation" src={imagotipo} onLoad={handleAnimation} alt="wholemeaning logo waiting" />
    </div>
  )
}

export default SplashScreen
